import { useQuery } from "@tanstack/react-query";
import { createApiClient } from "../utilities/apiClient";

const getSailTag = async (guid: string, size: number) => {
    const axiosSailTag = createApiClient();
    const response = await axiosSailTag.get(
        `/api/QRCode/GetSailTag/${encodeURIComponent(guid)}/${size}`,
        { responseType: "blob" },
    );
    return response.data;
};

export const useGetSailTag = (guid: string, size: number) =>
    useQuery({
        queryKey: [
            "GetQRCode",
            {
                id: guid ?? null,
            },
        ],
        queryFn: () => {
            return getSailTag(guid, size);
        },
        enabled: guid !== null && guid.length > 0,
        refetchOnWindowFocus: true,
        retry: false,
    });
